"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getStyles = getStyles;
exports.Control = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _react = require("@fluentui/react");

var _Control = require("./Control.base");

function getStyles(_ref) {
  var palette = _ref.theme.palette,
      inline = _ref.inline,
      _ref$showFocus = _ref.showFocus,
      showFocus = _ref$showFocus === void 0 ? true : _ref$showFocus,
      clickable = _ref.clickable,
      _ref$outlineInset = _ref.outlineInset,
      outlineInset = _ref$outlineInset === void 0 ? 0 : _ref$outlineInset,
      _ref$outlineColor = _ref.outlineColor,
      outlineColor = _ref$outlineColor === void 0 ? palette.neutralPrimary : _ref$outlineColor;
  return {
    root: {
      position: 'relative',
      display: inline ? 'inline-block' : 'block',
      outline: 'none',
      cursor: clickable ? 'pointer' : undefined,
      selectors: (0, _objectSpread2.default)({}, showFocus ? {
        ':focus:after': {
          content: "''",
          display: 'block',
          position: 'absolute',
          top: "".concat(outlineInset, "px"),
          right: "".concat(outlineInset, "px"),
          bottom: "".concat(outlineInset, "px"),
          left: "".concat(outlineInset, "px"),
          outline: "".concat(outlineColor, " solid 1px"),
          margin: '-2px 0',
          pointerEvents: 'none'
        }
      } : {})
    }
  };
}
/**
 * A user interactable control which emulates Office UI Fabric button
 * functionality, for arbitrary elements (i.e. non-buttons).
 *
 * Button emulation features:
 *
 * + Does not _show_ focus on click (even though it has focus).
 * + Shows focus when gained by tabbing.
 * + Uses an `:after` pseudo-element with an outline to show focus.
 * + Sets the cursor to a pointer when an `onClick` handler is provided.
 * + "Click" with spacebar or enter key.
 * + Has attribute "role" set to "button" for accessibility.
 */


var Control = (0, _react.styled)(_Control.ControlBase, getStyles);
exports.Control = Control;